import { AuthGuard, CrudOp, projectManagementAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { useRequiredProjectParam, useRequiredSubprojectParam } from "@org-avp/avp-avengers-ui-shared-store";
import { importView } from "@org-avp/avp-avengers-ui-shared-utils";
import { FC, lazy, Suspense } from "react";

export const BlacklistView: FC = () => {
  const projectId = useRequiredProjectParam("projectId");
  const subprojectId = useRequiredSubprojectParam("subprojectId");
  const brand = useRequiredProjectParam("brand");
  const modelYear = parseInt(useRequiredSubprojectParam("modelYear"));
  const mbvKeys = useRequiredSubprojectParam("mbvKeys", parseArrayAndSort);
  return (
    <AuthGuard authScope={projectManagementAuthScope} crudOp={CrudOp.READ} project={projectId}>
      <Suspense><LazyBlacklistView projectId={projectId} subprojectId={subprojectId} brand={brand} modelYear={modelYear} mbvKeys={mbvKeys}/></Suspense>
    </AuthGuard>
  );
};

const LazyBlacklistView = lazy(importView(
  () => import("../components/BlacklistView"),
  (it) => it.BlacklistView,
));

const parseArrayAndSort = (param: string): string[] => {
  return param.split(",").sort();
};
